export function getCurrentQuarter(): string {
  const now = new Date();
  const q = Math.ceil((now.getMonth() + 1) / 3);
  return `${now.getFullYear()}-Q${q}`;
}

export function getQuarterEndDate(quarter?: string): string {
  let year = new Date().getFullYear();
  let q = Math.ceil((new Date().getMonth() + 1) / 3);

  if (quarter) {
    const match = quarter.match(/^(\d{4})-Q(\d)$/);
    if (match) {
      year = parseInt(match[1]);
      q = parseInt(match[2]);
    }
  }

  const endMonth = q * 3;
  const lastDay = new Date(year, endMonth, 0);
  return lastDay.toISOString().slice(0, 10);
}

export function buildQuarterOptions(): { value: string; label: string }[] {
  const now = new Date();
  const currentYear = now.getFullYear();
  const currentQ = Math.ceil((now.getMonth() + 1) / 3);

  const options: { value: string; label: string }[] = [];
  for (let offset = -2; offset <= 6; offset++) {
    let q = currentQ + offset;
    let y = currentYear;
    while (q < 1) { q += 4; y--; }
    while (q > 4) { q -= 4; y++; }
    const value = `${y}-Q${q}`;
    const isCurrent = offset === 0;
    options.push({
      value,
      label: isCurrent ? `${value} (current)` : value,
    });
  }
  return options;
}

export const QUARTER_OPTIONS = buildQuarterOptions();
